module.exports = __webpack_public_path__ + "media/images/emblems/Wappen_Weesen-2189095ece4b7a28a4a484d8bd155085.svg";